import type { IconSvgObject } from './types';

const CircleArrowRight02Icon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 12.0002L7.99995 12.0002M12.5001 8.50012C12.5001 8.50012 16.0001 11.0778 16.0001 12.0001C16.0001 12.9225 12.5001 15.5001 12.5001 15.5001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowRight02Icon;
